import { reportNumber } from "./reportNumbers";

export function formatTraceabilityNumber(value) {
  const number = reportNumber(value);
  const hasDecimals = typeof value === "string" && value.includes(".");
  return hasDecimals || !Number.isInteger(number)
    ? number.toFixed(2)
    : String(number);
}

export function resolveUnitOfMeasureLabel(unitOfMeasure, fallbackLabel = null) {
  if (unitOfMeasure && typeof unitOfMeasure === "object") {
    return unitOfMeasure.label || unitOfMeasure.name || fallbackLabel || null;
  }

  if (fallbackLabel) {
    return fallbackLabel;
  }

  if (unitOfMeasure == null || unitOfMeasure === "") {
    return null;
  }

  const text = String(unitOfMeasure).trim();
  return /^\d+$/.test(text) ? null : text;
}

export function formatAmountWithUnit(
  value,
  unitOfMeasure,
  fallbackUnitLabel = null,
) {
  const formattedValue = formatTraceabilityNumber(value);
  const unitLabel = resolveUnitOfMeasureLabel(unitOfMeasure, fallbackUnitLabel);

  return unitLabel ? `${formattedValue} ${unitLabel}` : formattedValue;
}
